// Совместная правка тура: слияние правок двух людей по позициям. base — последняя версия с сервера, которую видел
// этот браузер; local — что у нас сейчас; server — новая версия с сервера (её сохранил другой участник).
// Своё изменённое (поле шапки или позиция) остаётся своим, остальное берём с сервера; удалённое у нас — удаляем,
// удалённое на сервере и не тронутое у нас — тоже удаляем; новое с обеих сторон — добавляем.
import type { PlanItem } from '@sayohat/shared';
import type { LocalPlan } from './model';

const HEAD = ['title', 'cities', 'startDate', 'endDate', 'travelers', 'budget', 'notes'] as const;
const same = (a: unknown, b: unknown): boolean => JSON.stringify(a) === JSON.stringify(b);

export function mergePlans(base: LocalPlan | null, local: LocalPlan, server: LocalPlan): LocalPlan {
  // Нет общей версии — правки этого браузера сверху серверной, позиции — объединение
  const b = base || { ...server, items: [] };
  const out: LocalPlan = { ...server, id: local.id, editKey: local.editKey, rev: server.rev };
  for (const k of HEAD) {
    if (!same(local[k], b[k])) (out as unknown as Record<string, unknown>)[k] = local[k];
  }
  const byId = (list: PlanItem[]) => new Map(list.map((x) => [x.id, x]));
  const B = byId(b.items);
  const L = byId(local.items);
  const S = byId(server.items);
  const items: PlanItem[] = [];
  // Порядок — серверный, наши новые — в конец
  for (const s of server.items) {
    const l = L.get(s.id);
    const was = B.get(s.id);
    if (!l) {
      // У нас удалено (было в base) — удаляем, если на сервере не меняли; не было в base — новое с сервера
      if (was && same(was, s)) continue;
      items.push(s);
      continue;
    }
    items.push(was && !same(l, was) ? l : s);
  }
  for (const l of local.items) {
    if (S.has(l.id)) continue;
    const was = B.get(l.id);
    // Удалено на сервере: если мы не меняли — не возвращаем; новое у нас — добавляем
    if (was && same(was, l)) continue;
    items.push(l);
  }
  out.items = items;
  return out;
}

/** Ссылка-приглашение: /plan/<id>#edit=<ключ> → ключ или '' */
export function editKeyFromHash(hash: string): string {
  const m = decodeURIComponent(hash || '').match(/(?:^#|&)edit=([\w-]{16,64})/);
  return m ? m[1] : '';
}
